module.exports = __webpack_public_path__ + "static/media/SRM-logo.8826a834.png";